<template>
    <td-dialog :title="$t(title)" v-dialogDrag :before-close="mqDialogClose" :visible.sync="dialogMqVisible" width="450px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :model="formMqInfo" ref="formMqInfo" :rules="rules" :label-width="formLabelWidth">
            <el-form-item :label="$t('common.MQNAME')" prop="sName">
                <td-input v-model="formMqInfo.sName" maxlength="50"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.TYPE')" prop="iType">
                <td-select v-model="formMqInfo.iType" :options="options"></td-select>
            </el-form-item>
            <el-form-item :label="$t('common.IP')" prop="sIp">
                <td-input v-model="formMqInfo.sIp"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.PORT')" prop="iPort">
                <td-inputNumber v-model="formMqInfo.iPort" :min="1" :max="65535"></td-inputNumber>
            </el-form-item>
            <el-form-item :label="$t('common.WEBSOCKET_PORT')" prop="iWebPort">
                <td-inputNumber v-model="formMqInfo.iWebPort" :min="1" :max="65535"></td-inputNumber>
            </el-form-item>
            <el-form-item :label="$t('common.WEB_PORT')" prop="iControllerPort">
                <td-inputNumber v-model="formMqInfo.iControllerPort" :min="1" :max="65535"></td-inputNumber>
            </el-form-item>
            <el-form-item :label="$t('common.USERNAME')" prop="sUsername">
                <td-input v-model="formMqInfo.sUsername"></td-input>
            </el-form-item>
            <el-form-item :label="$t('common.PASSWORD')" prop="sPassword">
                <input type="password" style="outline:none;border:0;width:0;height:0;float:left;background-color: rgba(0, 0, 0, 0);" />
                <td-input v-model="formMqInfo.sPassword" type="passWord" maxlength="16"></td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm('formMqInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="mqDialogClose">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import mqApi from '../assets/api.js';
export default {
    props: ['title', 'dialogMqVisible', 'editItem', 'isAddData'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAddData) {
            this.initEditData();
        } else {
            // mq类型默认选中第一个
            this.formMqInfo.iType = this.options[0].value;
        }
    },
    // 定义变量
    data() {
        let validateIpPort = (rule, value, callback) => {
            let sId = '';
            if (!this.isAddData) {
                sId = this.editItem.sId;
            }
            let param = {
                sId: sId,
                iPort: this.formMqInfo.iPort,
                sIp: this.formMqInfo.sIp
            };
            mqApi.checkIpPortRepeat(JSON.stringify(param), response => {
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('dialogMqinfo/checkIpPortRepeat', response);
                }
                if (response.data.content) {
                    callback(this.$t('pgMessage.IP_PORT_EXIST_PLEASE_INPUT'));
                    this.loading = false;
                    return;
                } else {
                    callback();
                }
            });
        };
        return {
            // mq表单信息
            formMqInfo: {
                sName: '',
                iType: [],
                sIp: '',
                iPort: '5673',
                iWebPort: '15674',
                iControllerPort: '15672',
                sUsername: '',
                sPassword: ''
            },
            // mq类型数组 ，暂时不支持activeMQ,先注掉
            options: [
                {
                    value: 0,
                    label: this.$t('common.RABBITMQ')
                } /*, {
                value: 1,
                label: this.$t('common.ACTIVEMQ')
            } */
            ],
            formLabelWidth: '35%',
            // 对表单进行数据验证
            rules: {
                sName: [{ required: true, message: this.$t('error.ERROR_CAPTION_NULL'), trigger: 'blur' }, { pattern: this.$regex.CAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }],
                sIp: [
                    { required: true, message: this.$t('error.ERROR_IP_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.IP_RULE, message: this.$t('error.ERROR_IP_ILLEGAL') },
                    { validator: validateIpPort, trigger: 'blur' }
                ],
                iType: [{ required: true, message: this.$t('error.ERROR_TYPE_NULL'), trigger: 'change' }],
                iPort: [{ required: true, message: this.$t('error.ERROR_PORT_NULL'), trigger: 'blur' }, { validator: validateIpPort, trigger: 'blur' }],
                iWebPort: [{ required: true, message: this.$t('error.ERROR_WEB_PORT_NULL'), trigger: 'blur' }],
                iControllerPort: [{ required: true, message: this.$t('error.ERROR_WEB_PORT_NULL'), trigger: 'blur' }],
                sUsername: [
                    { required: true, message: this.$t('error.ERROR_USERNAME_NULL'), trigger: 'blur' },
                    { pattern: this.$regex.USERCAPTION_RULE, message: this.$t('error.ERROR_CAPTION_ILLEGAL') }
                ],
                sPassword: [
                    { required: true, message: this.$t('error.ERROR_PASSWORD_NULL'), trigger: 'blur' },
                    { min: 1, max: 100, message: this.$t('error.ERROR_PASSWORD_MAX_LENGTH'), trigger: 'blur' },
                    {
                        pattern: this.$regex.PASSWORD_RULE,
                        message: this.$t('error.ERROR_USER_PASSWORD_ILLEGAL')
                    }
                ]
            },
            saveLoading: false
        };
    },
    // 定义并实现方法体
    methods: {
        // 初始化编辑数据
        initEditData() {
            this.formMqInfo.sName = this.editItem.sName;
            this.formMqInfo.iType = this.editItem.iType;
            this.formMqInfo.sIp = this.editItem.sIp;
            this.formMqInfo.iPort = this.editItem.iPort;
            this.formMqInfo.iWebPort = this.editItem.iWebsocketPort;
            this.formMqInfo.iControllerPort = this.editItem.iWebPort;
            this.formMqInfo.sUsername = this.editItem.sUsername;
            this.formMqInfo.sPassword = this.editItem.sPassword;
        },
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.saveLoading = true;
                    let content = {
                        sname: this.formMqInfo.sName,
                        itype: this.formMqInfo.iType,
                        sip: this.formMqInfo.sIp,
                        iport: this.formMqInfo.iPort,
                        iWebsocketPort: this.formMqInfo.iWebPort,
                        iWebPort: this.formMqInfo.iControllerPort,
                        susername: this.formMqInfo.sUsername,
                        spassword: this.formMqInfo.sPassword
                    };
                    if (this.isAddData) {
                        mqApi.insertMqInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dialogMqinfo/insertMqInfo', response.data.statusMessage);
                                this.saveLoading = false;
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.ADD_SUCCESS'), type: 'success' });
                            this.mqDialogClose();
                            this.saveLoading = false;
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('queryDataList');
                        });
                    } else {
                        content.sid = this.editItem.sId;
                        mqApi.updateMqInfo(JSON.stringify(content), response => {
                            if (response.data.statusCode !== window.pgCommon.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('dialogMqinfo/updateMqInfo', response.data.statusMessage);
                                this.saveLoading = false;
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('common.MODIFY_SUCCESS'), type: 'success' });
                            this.saveLoading = false;
                            this.mqDialogClose();
                            /* 编辑或添加完成需调用查询接口 */
                            this.$emit('queryDataList');
                        });
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        mqDialogClose() {
            this.$emit('mqDialogClose');
            this.$refs['formMqInfo'].resetFields(); // 重置表单数据
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
